import { Component, Input, OnDestroy, ViewChild } from '@angular/core';
import { EstablishmentFormComponent, EstablishmentFormValues } from '../../form/establishment-form.component';
import { FormModalDialogComponent } from '../../../common/form-modal-dialog/form-modal-dialog.component';
import { EstablishmentService } from '../../../../services/establishments/establishment.service';
import { Subject, takeUntil } from 'rxjs';

@Component({
    selector: 'app-create-establishment',
    templateUrl: './create-establishment.component.html',
    styleUrl: './create-establishment.component.scss',
    imports: [FormModalDialogComponent, EstablishmentFormComponent],
})
export class CreateEstablishmentComponent implements OnDestroy {
    protected readonly destroy$ = new Subject<void>();

    @ViewChild('modal')
    modalRef: FormModalDialogComponent;

    @Input({ required: true })
    organizationId: string;

    constructor(
        private readonly establishmentService: EstablishmentService,
    ) {
    }

    createEstablishment(values: EstablishmentFormValues) {
        this.establishmentService
            .createEstablishment({
                name: values.name,
                commissionPercentage: values.commissionPercentage ? Number(values.commissionPercentage) : undefined,
                parentEstablishmentId: values.parentEstablishmentId || undefined,
            })
            .pipe(takeUntil(this.destroy$))
            .subscribe(() => this.modalRef.close());
    }

    ngOnDestroy() {
        this.destroy$.next();
        this.destroy$.complete();
    }
}
